// extracted by mini-css-extract-plugin
export default {"downloadDesktopAppPage":"DownloadDesktopAppPage_downloadDesktopAppPage__G7O0p","panel":"DownloadDesktopAppPage_panel__VVhRr","muted":"DownloadDesktopAppPage_muted__5iLbp"};